import React, { useEffect, useState } from 'react';
import {
    BringzzTopBar,
    BringzzMap,
    BringzzImage,
    BringzzIcon,
    BringzzButton,
    BringzzText,
} from '@bringzz/components';
import { useOrder } from 'context/OrderContext'; // Use useOrder instead of useOverlay
import { useNavigation } from 'context/NavigationContext';
import useRequest from 'hooks/useRequest';
import useUser from 'hooks/useUser';
import { getOrderTypeString } from 'utils';
import { USER_ROLES, DELIVERY_TYPES_LABELS, getDeliveryTypeLabel } from 'utils/constants';
import { useTranslation } from 'react-i18next';

const OrderRequest = ({
    uuid,
}) => {
    const { hideOverlayContent, startMatchingProcess } = useOrder(); // Use hideOverlayContent from useOrder
    const { navigate } = useNavigation()
    const { sendRequest, data, error, loading } = useRequest();
    const { getUser } = useUser();
    const [orderDetails, setOrderDetails] = useState(null)
    const user = getUser();
    const { t } = useTranslation();

    console.log("order request orderDetails", orderDetails);

    const fetchOrderDetails = async () => await sendRequest({
        method: 'POST',
        url: `/module/order/getOrder`,
        data: {
            "orderUUID": uuid
        }
    }).then((response) => {
        if (response.status === 'success') {
            const reponseData = response.data

            setOrderDetails(reponseData)
            return response.data
        }
    }).catch((error) => {
        console.error(error);
        return;
    })

    useEffect(() => {
        fetchOrderDetails()
    }, [])

    const acceptOrder = async () => {
        console.log(orderDetails);

        if (orderDetails) {
            const data = await sendRequest({
                method: 'POST',
                url: `/module/order/acceptOrder`,
                data: {
                    "orderUUID": uuid
                }
            }).then((response) => {
                if (response.status === 'success') {
                    return response.data
                }
            }).catch((error) => {
                console.error(error);
            })

            if (data) {
                const orderDetails = await fetchOrderDetails()
                if (user.userRole == USER_ROLES.SHOPPER_ROLE && !data.order.prescriptionId) {
                    startMatchingProcess(orderDetails, 2)
                    navigate('/matchmaking/shopper/2')
                } else {
                    startMatchingProcess(orderDetails, 0)
                }
            }
        }
    }

    // Add loading state check before rendering content
    if (loading || !orderDetails) {
        return (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col justify-center items-center w-full p-4">
                <div className="bg-white px-4 py-12 rounded-lg w-full text-midnight-blue text-center">
                    <BringzzText>Loading order details...</BringzzText>
                </div>
            </div>
        );
    }

    // Handle error state
    if (error) {
        return (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col justify-center items-center w-full p-4">
                <div className="bg-white px-4 py-12 rounded-lg w-full text-midnight-blue text-center">
                    <BringzzText>Error loading order details. Please try again.</BringzzText>
                </div>
            </div>
        );
    }

    return (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col justify-center items-center w-full p-4 md:p-8 lg:p-12">
            <div className="bg-white px-4 py-12 rounded-lg w-full text-midnight-blue">
                <div className="text-center">
                    <div className="font-medium mb-4">
                        <BringzzText>Order request</BringzzText>
                    </div>
                    <div className="text-3xl font-bold">
                        <BringzzText className="font-bold text-3xl">€ {orderDetails.totalPrice || 0}</BringzzText>
                    </div>
                    <div>
                        <BringzzText tag="h5" className="font-regular">
                            {orderDetails.products.reduce((total, product) => total + (product.quantity || 1), 0) || "X"} Items
                        </BringzzText>
                    </div>
                    <div>
                        <BringzzText tag="h5" className="font-regular">
                            Estimated payment incl. tip
                        </BringzzText>
                    </div>
                </div>
                <div>
                    <div className="flex items-center justify-between p-4 border-b">
                        <span>
                            <BringzzText tag="h4" className="font-regular">
                                {orderDetails.customer.firstName || "consumer_name"}
                            </BringzzText>
                        </span>
                        <BringzzImage
                            src={orderDetails.customer.userPic || "/images/1.jpg"}
                            width="36px"
                            height="36px"
                            className="rounded-full !h-[36px]"
                        ></BringzzImage>
                    </div>
                    {user.userRole === USER_ROLES.PHARMACY_ROLE && (
                        <>
                            <div className="flex items-center justify-between p-3 border-b">
                                <div className="items-center flex gap-x-6">
                                    <BringzzIcon
                                        icon="IconMapMarker"
                                        folder="LineIcons"
                                        className="text-midnight-blue"
                                        size="24"
                                    ></BringzzIcon>
                                    <span>
                                        <BringzzText tag="h4" className="font-regular">
                                            Order Type
                                        </BringzzText>
                                    </span>
                                </div>
                                <span className="font-bold">
                                    <BringzzText>{getDeliveryTypeLabel(orderDetails.type, t)}</BringzzText>
                                </span>
                            </div>
                            <div className="flex items-center justify-between p-3 border-b">
                                <div className="items-center flex gap-x-6">
                                    <BringzzIcon
                                        icon="IconMapMarker"
                                        folder="LineIcons"
                                        className="text-midnight-blue"
                                        size="24"
                                    ></BringzzIcon>
                                    <span>
                                        <BringzzText tag="h4" className="font-regular">
                                            Order Total
                                        </BringzzText>
                                    </span>
                                </div>
                                <span className="font-bold">€ {orderDetails.totalPrice || 0}</span>
                            </div>
                        </>
                    )}

                    {user.userRole === USER_ROLES.SHOPPER_ROLE && (
                        <>
                            <div className="flex items-center justify-between p-3 border-b">
                                <div className="items-center flex gap-x-6">
                                    <BringzzIcon
                                        icon="IconMapMarker"
                                        folder="LineIcons"
                                        className="text-midnight-blue"
                                        size="24"
                                    ></BringzzIcon>
                                    <span>
                                        <BringzzText tag="h4" className="font-regular">
                                            Estimated total distance
                                        </BringzzText>
                                    </span>
                                </div>
                                <span className="font-bold">
                                    <BringzzText>9.9km</BringzzText>
                                </span>
                            </div>
                            <div className="flex items-center justify-between p-3 border-b">
                                <div className="items-center flex gap-x-6">
                                    <BringzzIcon
                                        icon="IconMapMarker"
                                        folder="LineIcons"
                                        className="text-midnight-blue"
                                        size="24"
                                    ></BringzzIcon>
                                    <span>
                                        <BringzzText tag="h4" className="font-regular">
                                            Estimated time
                                        </BringzzText>
                                    </span>
                                </div>
                                <span className="font-bold">20min</span>
                            </div>
                        </>
                    )}

                    <div className="flex p-4 mb-6 justify-between items-center cursor-pointer" onClick={() => {
                        hideOverlayContent()
                        
                        // Navigate to role-specific order details URL
                        let orderUrl = `/settings/orders/view/${uuid}`;
                        if (user?.userRole === USER_ROLES.PHARMACY_ROLE) {
                            orderUrl = `/settings/pharmacy/orders/view/${uuid}`;
                        } else if (user?.userRole === USER_ROLES.SHOPPER_ROLE) {
                            orderUrl = `/settings/shopper/orders/view/${uuid}`;
                        } else if (user?.userRole === USER_ROLES.CONSUMER_ROLE) {
                            orderUrl = `/settings/consumer/orders/view/${uuid}`;
                        }
                        
                        navigate(orderUrl)
                    }}>
                        <BringzzText tag="h4">View all details</BringzzText>
                        <BringzzIcon
                            icon="IconChevronDown"
                            folder="LineIcons"
                            size="12"
                            className="text-black"
                        />
                    </div>
                    <div className="flex items-center gap-x-4 mt-2 justify-center">
                        <BringzzButton
                            className="bg-white border-midnight-blue border-2"
                            onClick={hideOverlayContent}
                            disabled={loading}
                        >
                            Decline
                        </BringzzButton>
                        <BringzzButton className="bg-magic-lilac" onClick={acceptOrder} disabled={loading}>Accept</BringzzButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderRequest;
